import { Action } from '@ngrx/store';
import { Observable, race, forkJoin, of, throwError } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';
import { ofType, Actions } from '@ngrx/effects';
import { uuid, ErrorModel } from '@awp/core/utils';

export interface CorrelationId {
  id: string;
}

export class CorrelationAction {
  id: string;
  constructor(id: string) {
    this.id = id || uuid();
  }
}

export type AggregatableAction = Action & { id: string };

export type FailActionForAggregation = Action & { error?: ErrorModel, id: string };

const filterAction = (source: CorrelationId, target: CorrelationId) => target.id === source.id;

const getAggregatedActions = (source$: Observable<any>, sourceAction: CorrelationId, waitActions: string[], cancelActions: string[]): Observable<any[]> => {

  const waitMonitor$ = waitActions.map(a => {
      return source$.pipe(
        ofType(a),
        filter((action: AggregatableAction) => {
          return filterAction(sourceAction, action);
        }),
        first()
      );
    });

  const cancelMonitor$ = cancelActions.map(a => {
      return source$.pipe(
        ofType(a),
        filter((action: AggregatableAction) => {
          return filterAction(sourceAction, action);
        }),
        first(),
        switchMap((action: FailActionForAggregation)  => {
          return throwError(action.error);
        })
      );
    });

  return race(forkJoin([of(sourceAction), ...waitMonitor$]), ...cancelMonitor$);
};

// We be good to come back and revisit this at a later stage.
// export function aggregate(actions: Actions, waitActions: string[], cancelActions: string[]): OperatorFunction<any, Array<any>> {
//   return (source: Observable<AggregatableAction>) => {
//     return source.pipe(
//       switchMap(sourceAction => getAggregatedActions(actions, sourceAction, waitActions, cancelActions))
//     );
//   }
// }

// export function aggregateOfType(start: string, waitActions: string[], cancelActions: string[]): OperatorFunction<any, Array<any>> {
//   return (source: Observable<AggregatableAction>) => {
//     return source.pipe(
//       ofType(start),
//       switchMap(sourceAction => getAggregatedActions(source, sourceAction, waitActions, cancelActions))
//     );
//   }
// }

export function aggregate(actions: Actions, sourceAction: CorrelationId, waitActions: string[], cancelActions: string[]): Observable<any> {
  return getAggregatedActions(actions, sourceAction, waitActions, cancelActions);
}
